import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import { ReactComponent as CoreSvg } from "../../assets/svg/SVG-TEST2.svg";
import CoreNetworkSVG from "./svg/CoreNetworkSVG";

// assets
// import coreImg from "../../assets/images/CORENETWORK.jpg";
// import mobileBG from "../../assets/images/CN-MobileBG.jpg";
import img1 from "../../assets/images/MACROCELLTOWERS.png";
import img2 from "../../assets/images/FIBERNETWORKS.png";
import img3 from "../../assets/images/DATACENTERS.png";
import img4 from "../../assets/images/ROOFTOPCELL.png";
import img5 from "../../assets/images/OUTDOORDAS.png";
import img6 from "../../assets/images/SMALLCELLS.png";
import img7 from "../../assets/images/INDOORDAS.png";
import prev from "../../assets/images/prev-blue.png";
import next from "../../assets/images/next-blue.png";

// css
import "./di-styles.css";

const CoreNetwork = () => {
  // settings for the react slider
  const settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
  };

  const [screenSize, getDimension] = useState({
    dynamicWidth: window.innerWidth,
    dynamicHeight: window.innerHeight,
  });

  const setDimension = () => {
    getDimension({
      dynamicWidth: window.innerWidth,
      dynamicHeight: window.innerHeight,
    });
  };

  const slider = React.useRef(null);

  useEffect(() => {
    window.addEventListener("resize", setDimension);

    return () => {
      window.removeEventListener("resize", setDimension);
    };
  }, [screenSize]);
  return (
    <section className="core-network-wrapper" id="core-network">
      {screenSize.dynamicWidth > 700 ? (
        // <img style={{ width: "100%" }} src={coreImg} alt="core network" />
        // <CoreSvg />
        <CoreNetworkSVG />
      ) : (
        <div style={{ padding: "50px" }} className="my-carousel-container">
          <h1 className="sub-header t-center">Core Network</h1>
          <Slider ref={slider} {...settings}>
            <div className="t-center">
              <h1 className="t-center t-swifblue fw-5">Macro Cell Towers</h1>
              <img src={img1} alt="" style={{ width: "100%" }} />
            </div>
            <div className="t-center">
              <h1 className="t-center t-swifblue fw-5">Fiber Networks</h1>
              <img src={img2} alt="" style={{ width: "100%" }} />
            </div>
            <div className="t-center">
              <h1 className="t-center t-swifblue fw-5">Data Centers</h1>
              <img src={img3} alt="" style={{ width: "100%" }} />
            </div>
            <div className="t-center">
              <h1 className="t-center t-swifblue fw-5">Rooftop Cell Towers</h1>
              <img src={img4} alt="" style={{ width: "100%" }} />
            </div>
            <div className="t-center">
              <h1 className="t-center t-swifblue fw-5">Outdoor DAS</h1>
              <img src={img5} alt="" style={{ width: "100%" }} />
            </div>
            <div className="t-center">
              <h1 className="t-center t-swifblue fw-5">Small Cells</h1>
              <img src={img6} alt="" style={{ width: "100%" }} />
            </div>
            <div className="t-center">
              <h1 className="t-center t-swifblue fw-5">Indoor DAS</h1>
              <img src={img7} alt="" style={{ width: "100%" }} />
            </div>
          </Slider>
          <div className="custom-arrows-core">
            <div onClick={() => slider?.current?.slickPrev()}>
              <img src={prev} alt="previous" />
            </div>
            <div onClick={() => slider?.current?.slickNext()}>
              <img src={next} alt="next" />
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default CoreNetwork;
